import watchUltraLarge from '../../assets/images/promos/watch ultra large.jpg';
import watchUltraMedium from '../../assets/images/promos/watch ultra medium.jpg';
import watchUltraSmall from '../../assets/images/promos/watch ultra small.jpg';

import watchSeries8Large from '../../assets/images/promos/watch series8 large.jpg';
import watchSeries8Medium from '../../assets/images/promos/watch series8 medium.jpg';
import watchSeries8Small from '../../assets/images/promos/watch series8 small.jpg';

import ipadProLarge from '../../assets/images/promos/ipad pro large.jpg';
import ipadProMedium from '../../assets/images/promos/ipad pro medium.jpg';
import ipadProSmall from '../../assets/images/promos/ipad pro small.jpg';

import tv4kLarge from '../../assets/images/promos/tv4k large.jpg';
import tv4kMedium from '../../assets/images/promos/tv4k medium.jpg';
import tv4kSmall from '../../assets/images/promos/tv4k small.jpg';

import airpodsProLarge from '../../assets/images/promos/airpods pro large.jpg';
import airpodsProMedium from '../../assets/images/promos/airpods pro medium.jpg';
import airpodsProSmall from '../../assets/images/promos/airpods pro small.jpg';

import watchSeLarge from '../../assets/images/promos/watch se large.jpg';
import watchSeMedium from '../../assets/images/promos/watch se medium.jpg';
import watchSeSmall from '../../assets/images/promos/watch se small.jpg';

export const promoSectionImages = {
	firstPromoSection: {
		large: watchUltraLarge,
		medium: watchUltraMedium,
		small: watchUltraSmall,
	},
	secondPromoSection: {
		large: watchSeries8Large,
		medium: watchSeries8Medium,
		small: watchSeries8Small,
	},
	thirdPromoSection: {
		large: ipadProLarge,
		medium: ipadProMedium,
		small: ipadProSmall,
	},
	fourthPromoSection: {
		large: tv4kLarge,
		medium: tv4kMedium,
		small: tv4kSmall,
	},
	fifthPromoSection: {
		large: airpodsProLarge,
		medium: airpodsProMedium,
		small: airpodsProSmall,
	},
	sixthPromoSection: {
		large: watchSeLarge,
		medium: watchSeMedium,
		small: watchSeSmall,
	},
};
